import React, { useEffect, useState } from "react";
import VerticalLayout from "../components/VerticalLayout";
import Header from "../components/Header";
import { Col, Container, FormFeedback, Input, Label, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { Footer } from "../components/Footer";
import { ScaleLoader } from "react-spinners";
import InfiniteScroll from "react-infinite-scroll-component";
import ItemTrack from "../components/ItemTrack";
import { useProfile } from "../hooks/UserHooks";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Profile = () => {
  const { userProfile, updateProfile, defaultVolume } = useProfile();
  const navigate = useNavigate();

  const [hasMore, setHasMore] = useState(true);
  const [userProfileDynamique, setUserProfileDynamique] = useState(userProfile);
  const [volumeTrack, setVolumeTrack] = useState(defaultVolume);
  const [listFav, setListFav] = useState((userProfile?.favories || []).slice(0, 5));
  const [selectedTrack, setSelectedTrack] = useState(null);

  const toggleFav = (track) => {
    if (userProfileDynamique) {
      let user = { ...userProfileDynamique };
      user.favories = user.favories || [];
      let isExist = user.favories.find((e) => e.id === track.id);
      if (isExist) {
        user.favories = user.favories.filter((e) => e.id !== track.id);
      } else {
        user.favories.push(track);
      }
      setUserProfileDynamique(user);
      updateProfile(user);
    } else {
      navigate("/login");
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      lastname: userProfileDynamique?.lastname || "",
      firstname: userProfileDynamique?.firstname || "",
      email: userProfileDynamique?.email || ""
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Email invalide").required("Email obligatoire"),
      firstname: Yup.string().required("Prénom obligatoire"),
      lastname: Yup.string().required("Nom obligatoire")
    }),
    onSubmit: async (values) => {
      try {
        await updateProfile({ ...userProfileDynamique, ...values });
        toast.success("Profil mis à jour avec succès !");
      } catch (error) {
        toast.error("Erreur lors de la mise à jour du profil.");
      }
    }
  });

  useEffect(() => {
    if ((userProfile?.favories || []).length <= 5) {
      setHasMore(false);
    }
  }, [userProfile]);

  return (
    <>
      <VerticalLayout />
      <ToastContainer />
      <div className="body">
        <div className="container content-body">
          <Header />
          <Container>
            <Row>
              <Col lg={12}>
                <div className="card m-2 p-4 bg-dark">
                  <form onSubmit={validation.handleSubmit}>
                    <Row>
                      <Col></Col>
                      <Col>
                        <h3>Profile</h3>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Link
                          to={"/logout"}
                          style={{
                            padding: "8px 15px",
                            backgroundColor: "#dc3545",
                            color: "white",
                            textDecoration: "none",
                            borderRadius: "4px"
                          }}>
                          Déconnexion
                        </Link>
                      </Col>
                    </Row>
                    <Col className="d-flex flex-column align-items-start mt-3">
                      <Label>Nom</Label>
                      <Input
                        type="text"
                        name="lastname"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.lastname}
                        invalid={!!validation.errors.lastname}
                      />
                      {validation.errors.lastname && validation.touched.lastname && (
                        <FormFeedback
                          type="invalid"
                          style={{ display: "block" }}>
                          {validation.errors.lastname}
                        </FormFeedback>
                      )}
                    </Col>
                    <Col className="d-flex flex-column align-items-start mt-3">
                      <Label>Prénom</Label>
                      <Input
                        type="text"
                        name="firstname"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.firstname}
                        invalid={!!validation.errors.firstname}
                      />
                      {validation.errors.firstname && validation.touched.firstname && (
                        <FormFeedback
                          type="invalid"
                          style={{ display: "block" }}>
                          {validation.errors.firstname}
                        </FormFeedback>
                      )}
                    </Col>
                    <Col className="d-flex flex-column align-items-start mt-3">
                      <Label>Email</Label>
                      <Input
                        type="email"
                        name="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email}
                        invalid={!!validation.errors.email}
                      />
                      {validation.errors.email && validation.touched.email && (
                        <FormFeedback
                          type="invalid"
                          style={{ display: "block" }}>
                          {validation.errors.email}
                        </FormFeedback>
                      )}
                    </Col>
                    <Col className="d-flex flex-column align-items-start mt-3">
                      <button
                        type="submit"
                        className="btn btn-primary mt-3">
                        Enregistrer
                      </button>
                    </Col>
                  </form>
                </div>
              </Col>
              <Col lg={12}>
                <div className="m-2">
                  <h3>favories</h3>
                  <InfiniteScroll
                    hasMore={hasMore}
                    style={{ width: "100%" }}
                    dataLength={listFav.length}
                    next={() => {
                      const currentLength = listFav.length;
                      const nextData = (userProfile?.favories || []).slice(currentLength, currentLength + 5);
                      if (nextData.length > 0) {
                        setListFav([...listFav, ...nextData]);
                      } else {
                        setHasMore(false);
                      }
                    }}
                    loader={
                      <div className="m-5">
                        <ScaleLoader color="white" />
                      </div>
                    }>
                    <table className="w-100">{/* ... table ... */}</table>
                  </InfiniteScroll>
                </div>
              </Col>
            </Row>
          </Container>
          <Footer selectedTrack={selectedTrack} />
        </div>
      </div>
    </>
  );
};

export default Profile;
